import React from 'react';

import {
  Header,
  ListBoxSection,
  ListBoxSectionProps,
} from 'react-aria-components';
import styles from './TypeaheadSection.module.scss';

export type TypeaheadSectionProps = ListBoxSectionProps<object> & {
  /** A visible description of the item. */
  children: React.ReactNode;
  /** The size of the item. */
  size?: 'compact' | 'medium' | 'large';
  /** The label of the section. */
  label: string;
};

/**
 * An individual section to be rendered inside a `Typeahead` popover.
 */
export const TypeaheadSection = ({
  children,
  id,
  size = 'large',
  label,
  ...props
}: TypeaheadSectionProps) => {
  return (
    <ListBoxSection
      className={styles.listBoxSection}
      data-size={size}
      data-zds-typeahead-section
      id={id}
      {...props}
    >
      <Header className={styles.label}>{label}</Header>
      {children}
    </ListBoxSection>
  );
};
